import React from 'react';

import PropTypes from 'prop-types';

import SideNavigation from '@adsk/alloy-side-navigation';

/**
 * Skeleton for side navigation frame
 */
const SideNavigationLayout = React.forwardRef(
  ({ children, renderSideNavigation, style, ...props }, ref) => (
    <div
      {...props}
      ref={ref}
      css={[
        {
          display: 'flex',
          height: '100%',
        },
        style,
      ]}
    >
      {renderSideNavigation()}
      <div
        css={[
          {
            height: '100%',
            overflow: 'auto',
            flex: 1,
          },
        ]}
      >
        {children}
      </div>
    </div>
  )
);

SideNavigationLayout.displayName = 'SideNavigationLayout';

SideNavigationLayout.defaultProps = {
  renderSideNavigation: (props) => <SideNavigation {...props} />,
};

SideNavigationLayout.propTypes = {
  /** Page content */
  children: PropTypes.node,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Side navigation render function */
  renderSideNavigation: PropTypes.func,
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default SideNavigationLayout;
